import PropTypes from 'prop-types';
import Flux from '../../../flux/Flux';
import Languages from './Base/Badges/Languages';
import { Component, createElement } from 'react';

class ActorPlate extends Component {
	render() {
		return (
			<div className="actor-plate">
				<div className="actor-plate__actor">
					{createElement(this.props.headlineType ? this.props.headlineType : 'h3', { className: 'actor-plate__name' }, this.props.name)}
					{!this.props.hideAge ? <div className="actor-plate__age">({this.props.age})</div> : ''}
				</div>
				<div>
					<Languages spokenLanguages={this.props.spokenLanguages} name={this.props.name} />
					{this.props.totalVideosCount > 0 && (
						<div className={'context-box--media-box__list__item -videos -right'}>{this.props.totalVideosCount + ' Videos'}</div>
					)}
				</div>
			</div>
		);
	}
}

ActorPlate.propTypes = {
	name: PropTypes.string.isRequired,
	age: PropTypes.number.isRequired,
	showSpokenLanguages: PropTypes.bool,
	spokenLanguages: PropTypes.array,
	totalVideosCount: PropTypes.number,
	hideAge: PropTypes.bool,
	headlineType: PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
};

ActorPlate.defaultProps = {
	showSpokenLanguages: true,
	totalVideosCount: 0,
};

export default ActorPlate;
